export default __webpack_public_path__ + "static/media/both-modules-phones.f57940dd.png";